import WebshopOrderSummary from './WebshopOrderSummary'

export default WebshopOrderSummary
